import { Flex, IconCurrencyCircleDollar, Text, csx } from '@vtex/admin-ui'
import { useIntl } from 'react-intl'
import { CURRENCY_FRACTION_DIGITS } from 'shared'
import type { OrderValue } from 'typings'
import { Tag } from '../../../Tag'
import { useNumbers } from '../../../utils/useNumbers'
import {
  Rule,
  RuleActions,
  RuleContent,
  RuleDescription,
  RuleIcon,
} from '../../RuleStack'
import { RuleDefaultActions } from '../../RuleStack/DefaultActions'
import { messages } from './messages'

type Props = {
  config: OrderValue | undefined
  onEdit: () => void
  onRemove: () => void
}

export function getOrderValueCriteria(config: OrderValue) {
  const { min, max } = config

  if (min && !max) return 'floor'
  if (!min && max) return 'ceil'
  else return 'range'
}

export function OrderValueView(props: Props) {
  const { config, onEdit, onRemove } = props

  const { formatCurrency } = useNumbers()

  const { $t } = useIntl()

  if (!config) return null

  const { min, max } = config

  const criteria = getOrderValueCriteria(config)

  return (
    <Rule onClick={onEdit}>
      <RuleIcon>
        <IconCurrencyCircleDollar />
      </RuleIcon>

      <RuleDescription>
        {$t(messages.view.title, {
          b: (content: React.ReactNode) => (
            <Text variant="body">{content}</Text>
          ),
          criteria,
        })}
      </RuleDescription>

      <RuleContent>
        {criteria === 'floor' && <Tag>{formatCurrency(min ?? 0)}</Tag>}

        {criteria === 'ceil' && <Tag>{formatCurrency(max ?? 0)}</Tag>}

        {criteria === 'range' && (
          <Flex align="center" className={csx({ columnGap: '$space-2' })}>
            {$t(messages.view.intervalValue, {
              minValue: <Tag>{formatCurrency(min ?? 0)}</Tag>,
              maxValue: <Tag>{formatCurrency(max ?? 0)}</Tag>,
            })}
          </Flex>
        )}
      </RuleContent>

      <RuleActions>
        <RuleDefaultActions onEdit={onEdit} onRemove={onRemove} />
      </RuleActions>
    </Rule>
  )
}
